module.exports = __webpack_public_path__ + "static/media/ccard-master.f945cb3c.svg";